export default __webpack_public_path__ + "static/media/illustration-recruit-1-m@3x.7d8dbeae.webp";